import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  ActivityLogSchema,
  ActivityUserMetaDataSchema,
} from './activity-log.schema';

export const activityLogContract = createRESTContract({
  getActivityLogs: {
    method: 'GET',
    path: '/logs',
    permissions: [PERMISSIONS.LOGS.VIEW_LOGS],
    response: z.array(ActivityLogSchema),
    query: z.object({
      filter: z.string().optional(),
    }),
  },
  getActivityLogDetails: {
    method: 'GET',
    path: '/logs/details/:id',
    permissions: [PERMISSIONS.LOGS.VIEW_CONVERSATION_LOGS],
    response: ActivityUserMetaDataSchema,
  },
});
